import { createFileRoute } from '@tanstack/react-router'
import AutentiqueConfigPage from '@/pages/dashboard/autentique-config-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/autentique',
)({
  component: AutentiqueConfigPage,
})
